<template>
  <div>
    <section class="g-headerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <router-link to="/" class="logo">
              <img :src="$store.getters.user.company_logo" />
            </router-link>
            <div class="title">
              {{ model.name }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="g-headerExamSpace"></div>

    <section class="container-fluid g-ExamPercentBox">
      <div class="container">
        <div class="col-24 box">
          <div class="name">姓名：{{ $store.getters.user.first_name }}</div>
          <div class="center">
            <div class="number">
              <i class="uc-blue"> {{ answerCount }}</i>
              /
              {{ questionCount }}
            </div>
            <el-progress :percentage="answerProcess"></el-progress>
          </div>
        </div>
      </div>
    </section>
    <div class="g-ExamPercentBoxSpace"></div>

    <section class="container-fluid uc-bg uc-Exam">
      <div class="container">
        <div class="list">
          <div v-for="(item, index) in model.question_type_list" :key="index">
            <div class="title">{{ item.cn_index }}、{{ item.type_name }}</div>
            <div v-for="(item2, index2) in item.question_list" :key="index2">
              <div class="item" :id="`question_${index}_${index2}`">
                <div class="sub-title">
                  <span>{{ index2 + 1 }}.</span>
                  <div class="qst-con w-e-text" v-html="item2.content"></div>
                </div>
                <!--单选&分值-->
                <el-radio-group
                  v-model="item2.options_check"
                  class="choose-box"
                  v-if="item.type == 1 || item.type == 2"
                >
                  <el-radio
                    v-for="(itemOption, indexOption) in item2.options"
                    :key="indexOption"
                    :label="itemOption"
                    class="choose-item"
                    @change="handleCount"
                  >
                    {{ itemOption }}
                  </el-radio>
                </el-radio-group>
                <!--多选-->
                <el-checkbox-group
                  v-model="item2.options_check_array"
                  class="choose-box"
                  v-if="item.type == 3"
                >
                  <el-checkbox
                    v-for="(itemOption, indexOption) in item2.options"
                    :key="indexOption"
                    :label="itemOption"
                    class="choose-item"
                    @change="handleCount"
                  >
                    {{ itemOption }}
                  </el-checkbox>
                </el-checkbox-group>
                <!--问答-->
                <div class="textarea-box" v-if="item.type == 4">
                  <textarea
                    class="uc-textarea"
                    placeholder="这里输入问题描述"
                    cols="30"
                    rows="10"
                    v-model="item2.options_check"
                    @blur="handleCount"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="g-footerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <button
              @click="btnSubmitSure"
              class="uc-btn blue uc-ml80"
              :disabled="submitSure"
            >
              提交
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="g-footerExamSpace"></div>

    <!-- <div class="uc-alert uc-alert-examSubmitSure" v-if="submitSure">
      <div class="over-close"></div>
      <div class="box">
        <div class="con">
          您还有10道题未答，是否确定退出考试？
        </div>
        <div class="operate">
          <button @click="" class="uc-btn black">取消</button>
          <button class="uc-btn black">仅保存</button>
          <button @click="btnSubmitSure" class="uc-btn blue">确定</button>
        </div>
        <div class="tips">
          <span></span>
          <span>保存后可继续答题</span>
          <span></span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireAnswer',
  components: {},
  data() {
    return {
      query: {
        id: this.$route.params.id,
        from: this.$route.query.from,
        fromId: this.$route.query.fromId,
      },
      model: {},
      questionCount: 0, // 问卷试题总数量
      answerCount: 0, // 作答数量
      noticeMsg: '',
      noticeIndex: [],
      submitSure: false,
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    // 作答进度
    answerProcess: {
      get() {
        const process =
          this.questionCount === 0
            ? 0
            : Math.round((this.answerCount / this.questionCount) * 100);
        return process;
      },
    },
  },
  methods: {
    loadData() {
      this.getQst();
    },
    async getQst() {
      const response = await this.$api.qst.getQst(this.query);
      if (response.data.code === 200) {
        this.model = response.data.data;
        this.questionCount = response.data.data.question_count;
      } else {
        this.submitSure = true;
        this.alertMessage('warning', response.data.message, true);
      }
    },
    async postQstAnswer(myanswer) {
      const response = await this.$api.qst.postQstAnswer(myanswer);
      if (response.data.code === 200) {
        this.alertMessage('success', response.data.message, true);
      } else {
        this.alertMessage('warning', response.data.message, true);
      }
    },
    chkSubmitData() {
      // 题型list
      const questionTypeList = this.model.question_type_list;
      for (const [index, questionType] of questionTypeList.entries()) {
        // 试题list
        const questionList = questionType.question_list;
        const qtype = questionType.type;
        const qtypeName = questionType.type_name;
        for (const [index2, question] of questionList.entries()) {
          // 1单选 & 2分值 & 4问答
          if (qtype === 1 || qtype === 2 || qtype === 4) {
            const result = question.options_check;
            if (result.length === 0) {
              this.noticeMsg = qtypeName + '：第 ' + (index2 + 1) + ' 题未答';
              this.noticeIndex = [index, index2];
              return false;
            }
          } else {
            // 3多选
            const resultArray = question.options_check_array;
            if (resultArray.length === 0) {
              this.noticeMsg = qtypeName + '：第 ' + (index2 + 1) + ' 题未答';
              this.noticeIndex = [index, index2];
              return false;
            }
          }
        }
      }
      return true;
    },
    btnSubmitSure() {
      if (this.chkSubmitData()) {
        this.submitSure = true;
        // 提交数据
        const submitData = {
          questionnaire_id: this.model.id,
          answer_id: this.model.answer_id,
          answer_details: [],
        };
        // 题型list
        const questionTypeList = this.model.question_type_list;
        for (const questionType of questionTypeList) {
          // 试题list
          const questionList = questionType.question_list;
          const qtype = questionType.type;
          for (const question of questionList) {
            const obj = {};
            obj.question_id = question.id;
            obj.question_type = qtype;
            // 1单选 & 2分值 & 4问答
            if (qtype === 1 || qtype === 2 || qtype === 4) {
              obj.result = question.options_check.trim();
            } else {
              // 3多选
              obj.result_array = question.options_check_array;
            }
            submitData.answer_details.push(obj);
          }
        }
        // console.log(submitData);
        this.postQstAnswer(submitData);
      } else {
        this.submitSure = false;
        this.alertMessage('warning', this.noticeMsg);
        const top = document.getElementById(
          `question_${this.noticeIndex[0]}_${this.noticeIndex[1]}`
        ).offsetTop;
        window.scrollTo(0, top - 172);
      }
    },
    handleCount() {
      const submitData = [];
      // 题型list
      const questionTypeList = this.model.question_type_list;
      for (const questionType of questionTypeList) {
        // 试题list
        const questionList = questionType.question_list;
        const qtype = questionType.type;
        for (const question of questionList) {
          // 1单选 & 2分值 & 4问答
          if (qtype === 1 || qtype === 2 || qtype === 4) {
            const result = question.options_check;
            if (result.length > 0) {
              submitData.push(result);
            }
          } else {
            // 3多选
            const resultArray = question.options_check_array;
            if (resultArray.length > 0) {
              submitData.push(resultArray);
            }
          }
        }
      }
      // 作答数量
      this.answerCount = submitData.length;
    },
    alertMessage(action, msg, isClose) {
      this.$message({
        type: action,
        message: msg,
        onClose: () => {
          if (isClose) {
            window.opener = null;
            window.open('about:blank', '_top').close();
          }
        },
      });
    },
  },
};
</script>
